import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal';

interface ConfirmRestoreAllModalProps {
  count: number;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const ConfirmRestoreAllModal: React.FC<ConfirmRestoreAllModalProps> = ({
  count,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen onClose={onCancel} title={t('restore_all_modal_title')} hideCloseButton isCentered>
      <p>{t('restore_all_modal_body', { count })}</p>
      <div className="modal-buttons">
        <button className="modal-button cancel" onClick={onCancel} disabled={loading}>
          {t('cancel')}
        </button>
        <button className="modal-button confirm" onClick={onConfirm} disabled={loading}>
          {loading ? t('saving') : t('restore_all_modal_confirm')}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmRestoreAllModal;
